import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Highlight } from './ui/Highlight';
export function Hero() {
  return <header className="relative min-h-screen flex flex-col justify-center pt-20 pb-20 md:pt-32" data-id="element-52">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-54">
          {/* Product title + Cover image */}
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 mb-16" data-id="element-55">
            <div className="flex-1" data-id="element-56">
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-extrabold tracking-tight leading-[0.95]" data-id="element-57">
                AI Clientes <br data-id="element-58" />
                <span className="text-primary" data-id="element-59">en 7 Días</span>
              </h1>
            </div>
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.3
          }} className="w-64 md:w-80 shrink-0" data-id="element-60">
              <div className="relative" data-id="element-61">
                <div className="absolute -inset-4 bg-primary/10 blur-2xl rounded-lg opacity-50" data-id="element-62"></div>
                <img src="https://cdn.magicpatterns.com/uploads/saVoa1zejTbhbRo8QcHpts/AI_Clientes_en_7_Dias_PORTADA.png" alt="AI Clientes en 7 Días - Portada" className="relative w-full rounded-lg shadow-2xl shadow-black/50 border border-white/10" data-id="element-63" />
              </div>
            </motion.div>
          </div>

          {/* Confrontational opener */}
          <div className="mb-12" data-id="element-64">
            <h2 className="text-3xl md:text-4xl font-display font-bold mb-8" data-id="element-65">
              TÚ NO ESTÁS{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white/50 to-white/50 line-through decoration-white/50 decoration-4" data-id="element-66">
                ATORADO
              </span>
              . <span className="text-primary" data-id="element-67">ESTÁS ENTRETENIDO.</span>
            </h2>
          </div>

          <div className="space-y-8 text-xl md:text-2xl text-gray-300 leading-relaxed max-w-2xl border-l-2 border-primary/30 pl-6 md:pl-10" data-id="element-68">
            <p data-id="element-69">
              Entre prompts, herramientas, videos, hilos, gurús… te armaste una
              jaula elegante:
              <span className="text-white font-medium" data-id="element-70">
                {' '}
                la sensación de avance sin el riesgo de vender.
              </span>
            </p>
            <p data-id="element-71">
              Porque vender implica una posibilidad real: que te ignoren. Y si
              te ignoran, tu cerebro lo traduce como:{' '}
              <span className="italic" data-id="element-72">"no soy suficiente"</span>.
            </p>
            <p data-id="element-73">Por eso te escondes en la parte cómoda: aprender.</p>
          </div>

          <div className="mt-16 flex flex-col sm:flex-row gap-4 items-start" data-id="element-74">
            <a href="#precio" data-id="element-75">
              <Button size="lg" withArrow data-id="element-76">
                QUIERO MI PRIMER CLIENTE
              </Button>
            </a>
            <p className="text-sm text-gray-500 mt-4 sm:mt-0 sm:ml-4 max-w-xs" data-id="element-77">
              *Este no es otro curso de prompts. Es un sistema operativo de
              ventas.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Background subtle grid */}
      <div className="absolute inset-0 -z-10 bg-[linear-gradient(to_right,#1f1f1f_1px,transparent_1px),linear-gradient(to_bottom,#1f1f1f_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20" data-id="element-78"></div>
    </header>;
}